export default __webpack_public_path__ + "static/media/Slide23.98824158.PNG";